 import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined, RocketOutlined, ThunderboltOutlined } from '@ant-design/icons';
import './LoadingAnimation.css';

interface LoadingAnimationProps {
  size?: 'small' | 'default' | 'large';
  message?: string;
  type?: 'default' | 'pulse' | 'orbit' | 'wave' | 'rocket';
  overlay?: boolean;
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  size = 'large',
  message = 'Loading...',
  type = 'default',
  overlay = false
}) => {
  const renderAnimation = () => {
    switch (type) {
      case 'pulse':
        return (
          <div className="loading-pulse">
            <div className="pulse-dot pulse-dot-1"></div>
            <div className="pulse-dot pulse-dot-2"></div>
            <div className="pulse-dot pulse-dot-3"></div>
          </div>
        );
      
      case 'orbit':
        return (
          <div className="loading-orbit">
            <div className="orbit-center"></div>
            <div className="orbit-ring">
              <div className="orbit-dot orbit-dot-1"></div>
              <div className="orbit-dot orbit-dot-2"></div>
              <div className="orbit-dot orbit-dot-3"></div>
            </div>
          </div>
        );
      
      case 'wave':
        return (
          <div className="loading-wave">
            <div className="wave-bar wave-bar-1"></div>
            <div className="wave-bar wave-bar-2"></div>
            <div className="wave-bar wave-bar-3"></div>
            <div className="wave-bar wave-bar-4"></div>
            <div className="wave-bar wave-bar-5"></div>
          </div>
        );
      
      case 'rocket':
        return (
          <div className="loading-rocket">
            <RocketOutlined className="rocket-icon" />
            <div className="rocket-trail"></div>
          </div>
        );
      
      default:
        return (
          <Spin
            size={size}
            indicator={
              <LoadingOutlined 
                style={{ 
                  fontSize: size === 'large' ? 48 : size === 'default' ? 24 : 16,
                  color: '#1890ff'
                }} 
                spin 
              />
            }
          />
        );
    }
  };

  const content = (
    <div className={`loading-container ${overlay ? 'loading-overlay' : ''}`}>
      <div className="loading-content">
        {renderAnimation()}
        {message && (
          <div className="loading-message">
            {message}
          </div>
        )}
      </div>
    </div>
  );

  return overlay ? (
    <div className="loading-overlay-backdrop">
      {content}
    </div>
  ) : content;
};

export default LoadingAnimation;
